module.exports = __webpack_public_path__ + "img/1577607148.9d14a0f4.jpg";